<template>
	<!-- 添加新建项目弹窗 -->
	<div class="editManage">
		<el-dialog :title="isEdit ? $t('MyProjectManagementEdit.txt1') : $t('MyProjectManagementEdit.txt2')" :visible="visible" @close="close" :closeOnClickModal="false">
		<el-form :model="addProjectInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
			<el-form-item label="" prop="projectName">
				<el-input :placeholder="$t('MyProjectManagementEdit.txt3')" v-model="addProjectInfo.projectName"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" class="confirmbtn" @click="submitForm('ruleForm')">{{$t('MyProjectManagementEdit.txt4')}}</el-button>
			<el-button class="cancelbtn" @click="resetForm('ruleForm')">{{$t('MyProjectManagementEdit.txt5')}}</el-button>
		</div>
	</el-dialog>
	</div>
</template>

<script>
import qs from "qs";
export default {
	props: {
		isEdit: Boolean,
		visible: Boolean,
		addProjectInfo: {
			type: Object,
			default() {
				return {
					projectName: ""
				};
			},
		},
	},
	watch: {
		visible() {
			if (this.visible) {
				this.loadData();
			}
		},
		isEdit() {
			if (!this.isEdit) {
				this.addProjectInfo.projectName = '';
			}
		},
	},
	data() {
		return {
			loading: false,
			userOptions: [],
			rules:{
			projectName:[
         		{ required: true, message: this.$t('MyProjectManagementEdit.txt6'), trigger: 'blur' },
      			{ pattern: /^[a-zA-Z]+[\d\w]*$/,message: this.$t('MyProjectManagementEdit.txt7'),trigger: "blur"},
         		]
			}
		};
	},
	methods: {
	// 用户管理列表
		async loadData() {
			let queryInfo = {
				name:''
			};
			const { data: res } = await this.$http.post(
				"/user/info/list/all?" + qs.stringify(queryInfo)
			);
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.userOptions = res.result;
		},
		close() {
			this.$emit("update:visible", false);
		},
		submitForm(formName) {
      		  this.$refs[formName].validate((valid) => {
				if (valid) {
					this.addProject();
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		// 项目添加
		async addProject() {
			let form = JSON.parse(JSON.stringify(this.addProjectInfo));
			if (this.loading) return;
			this.loading = true;
			const { data: res } = await this.$http.post("/project/add?"+qs.stringify(form));
			this.loading = false;
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.addProjectInfo.projectName = '';
			this.close();
			this.$emit("success");
		},
		resetForm(formName) {
      		this.$refs[formName].resetFields();
			this.addProjectInfo.projectName = '';
			this.close();
		},
	},
};
</script>
<style lang="less" scoped>
	.editManage{
		/deep/ .el-dialog{
			width: 42rem;
			height: 20.9rem;
			border-radius: 3rem;
			.el-dialog__header{
				width: 100%;
				text-align: center;
			}
			.el-dialog__header{
				border-bottom: 1px solid #F0F2F6;
			}
			.el-dialog__headerbtn{
				display: none;
			}
			.el-input__inner{
				width: 36rem;
				height: 36px;
				background: #F4F4F4;
				border-radius: 18px;
				border: none;
				font-size: 14px;
				line-height: 36px;
			}
			.el-dialog__body{
				height: 8rem;
				padding: 2rem 3rem 3rem 3rem;
			}
			.confirmbtn{
				width: 88px;
				height: 36px;
				background: #1B3B7C;
				border-radius: 18px;
			}
			.cancelbtn{
				width: 88px;
				height: 36px;
				background: #fff;
				border-radius: 18px;
				border: none;
				color: #1B3B7C;
			}
		}
		
	} 
</style>